export const title = 'Submit Your Resume';
export const contactTitle = 'Contact Information';
export const careerTitle = 'Career Level and Education Information';
export const addTitle = 'Additional Information';
export const subTitle = 'Are you authorized to work in the United States?';
export const uploadTitle = 'Upload Resume';
export const link = 'Submit';

export const uploadLink = 'Choose File';
